import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const formsNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Forms,
  route: RoutesEnum.Forms,
  icon: 'description',
};
